import { useStoreState } from "ezStore";
import { Select } from "@cofano/cck";
import { DataFormat } from "imports/Utils";
import { StatusFragmentFragment as StatusFragment } from "__generated__/view/statuses/graphql/fragments.generated";

export type StatusSelectOption = Pick<StatusFragment, "id" | "type" | "description" | "translations" | "color">

type StatusSelectProps = {
	value: StatusSelectOption | undefined;
	onChange: (value: StatusSelectOption | undefined) => void;
	multiple?: false;
} | {
	value: StatusSelectOption[] | undefined;
	onChange: (value: StatusSelectOption[] | undefined) => void;
	multiple: true;
};

type DefaultSelectProps = {
	statuses: StatusSelectOption[];
	label?: string;
}

const StatusSelect = ({ statuses, value, onChange, multiple, label }: StatusSelectProps & DefaultSelectProps) => {

	const session = useStoreState(state => state.session);

	return (
		<Select
			value={value}
			fetchOptions={statuses}
			label={label}
			onChange={(option) => {
				if (!option) {
					onChange(undefined);
				} else if (Array.isArray(option) && multiple) {
					onChange(option);
				} else if (!Array.isArray(option) && !multiple) {
					onChange(option);
				}
			}}
			getOptionColor={(option) => {
				return option.color;
			}}
			getOptionLabel={option => DataFormat.status(option, session.locale)}
			multiple={multiple} />
	);
};

export default StatusSelect;
